import { useEffect } from 'react';
import { Metrics, OPEN_REMOTE } from 'calling-remote-common/utils/Metrics';
export const useOpenRemoteOnCallAnswered = (openRemote, shouldShowActiveCallState) => {
  useEffect(() => {
    if (shouldShowActiveCallState) {
      openRemote();
      Metrics.counter(OPEN_REMOTE, {
        source: 'call-answered'
      }).increment();
    }
  }, [shouldShowActiveCallState, openRemote]);
};